import React, { useState } from 'react'
import { 
  Box, 
  Container,
  useTheme
} from '@mui/material'
import HowItWorks from './HowItWorks'
import FeaturedServices from './FeaturedServices'
import ModernHiringTools from './ModernHiringTools'
import TestimonialsSection from './TestimonialsSection'
import StatsShowcase from './StatsShowcase'

const TabbedContent = () => {
  const theme = useTheme()
  const [activeTab, setActiveTab] = useState(0) // 0 = For Clinicians, 1 = For Health Systems


  return (
    <Box sx={{ 
      py: { xs: 4, sm: 6 },
      backgroundColor: theme.palette.background.default
    }}>
      <Container maxWidth="lg">
        {/* Toggle Switch Style Navigation */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          mb: { xs: 3, sm: 4 },
          px: { xs: 2, sm: 0 }
        }}>
        <Box
          sx={{
            backgroundColor: theme.palette.grey[100],
            borderRadius: '50px',
            padding: '4px',
            display: 'flex',
            position: 'relative',
            boxShadow: theme.palette.shadows.light
          }}
        >
          {/* Background slider */}
          <Box
            sx={{
              position: 'absolute',
              top: '4px',
              left: activeTab === 0 ? '4px' : '50%',
              width: 'calc(50% - 4px)',
              height: 'calc(100% - 8px)',
              backgroundColor: theme.palette.common.white,
              borderRadius: '46px',
              transition: 'left 0.3s ease-in-out',
              boxShadow: theme.palette.shadows.light,
              zIndex: 1
            }}
          />
          
          {/* Tab buttons */}
          <Box
            onClick={() => setActiveTab(0)}
            sx={{
              px: { xs: 3, sm: 4 },
              py: { xs: 1.5, sm: 2 },
              borderRadius: '46px',
              cursor: 'pointer',
              position: 'relative',
              zIndex: 2,
              color: activeTab === 0 ? theme.palette.primary.main : theme.palette.text.secondary,
              fontWeight: activeTab === 0 ? 600 : 500,
              fontSize: { xs: '1rem', sm: '1.1rem' },
              transition: 'color 0.3s ease',
              minWidth: { xs: '140px', sm: '180px' },
              textAlign: 'center',
              '&:hover': {
                color: activeTab === 0 ? theme.palette.primary.main : theme.palette.text.primary
              }
            }}
          >
            For Clinicians
          </Box>
          
          <Box
            onClick={() => setActiveTab(1)}
            sx={{
              px: { xs: 3, sm: 4 },
              py: { xs: 1.5, sm: 2 },
              borderRadius: '46px',
              cursor: 'pointer',
              position: 'relative',
              zIndex: 2,
              color: activeTab === 1 ? theme.palette.primary.main : theme.palette.text.secondary,
              fontWeight: activeTab === 1 ? 600 : 500,
              fontSize: { xs: '1rem', sm: '1.1rem' },
              transition: 'color 0.3s ease',
              minWidth: { xs: '140px', sm: '180px' },
              textAlign: 'center',
              '&:hover': {
                color: activeTab === 1 ? theme.palette.primary.main : theme.palette.text.primary
              }
            }}
          >
            For Health Systems
          </Box>
        </Box>
      </Box>

      </Container>
      
      {/* Full Width Content */}
      {activeTab === 0 && (
        <Box>
          {/* For Clinicians Content */}
          <HowItWorks />
          <FeaturedServices />
        </Box>
      )}
      
      {activeTab === 1 && (
        <Box>
          {/* For Health Systems Content */}
          <ModernHiringTools />
          <TestimonialsSection />
          <StatsShowcase />
        </Box>
      )}
    </Box>
  )
}

export default TabbedContent
